/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { findChargerQrSelector } from "../../recoil/variableAtom";
import { ColorCircle, ContentBox, Layout } from "./style";
import { Blank, Div, EvButton, Font, Form, Input, Row } from "../../styles/commonStyle";
import { greenColor, modalGreyBtnColor, noticeRedColor, orangeBtnGradient, orangeColor, primaryColor } from "../../styles/theme";
import bgImage from "../../assets/images/img-bg-full-apply.jpg";
import { Charger, ChargerSttus, PlugCategory } from "../../model/charger";
import { RESULT, ResponseModel } from "../../model/response";
import useFetch from "../../hooks/useFetch";

function QRDetailPage() {
  let navigate = useNavigate();
  const { qrcode } = useParams();
  const [getQuery, setQuery] = useState<any>();

  useEffect(() => {
    setQuery({
      qrcode: qrcode,
    });
  }, []);

  useEffect(() => {
    navigate("charging_info");
  }, []);

  return (
    <Layout image={bgImage}>
      <ContentBox paddingLeft="1.5rem" paddingRight="1.5rem">
        
      </ContentBox>
    </Layout>
  );
}

export default QRDetailPage;
